<template>
  <div class="footer-nav">
    <div class="col-md-12 text-center">
      <p>Copyright © 2012-2016 四海富博</p>
      <p>北京四海富博计算机服务有限公司（京ICP备15010411号-1）</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer-nav {
  background: #0c9af4;
  color: #ffffff;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 20px 0;
}
p {
  margin: 10px 0;
  cursor: default;
}
@media only screen and (max-width: 600px) {
  .footer-nav {
    padding: 10px 0;
  }
  p {
    margin: 5px 0;
  }
}
</style>
